<template>
    <article class="lookup">
        <input type="text"
               :id="id"
               :placeholder="placeholder"
               autocomplete="off"
               name="name"
               class="form__input lookup__input"
               v-model="query"
               @keydown.down="down"
               @keydown.up="up"
               @keydown.enter="hit($event)"
               @keydown.esc.prevent="reset"
               @input="update"/>

        <aside class="lookup__results" v-show="hasItems">
            <div :key="index" class="lookup__item" v-for="(item, index) in items" :class="{ 'lookup__item--active' : current === index }" @mousedown="hit" @mousemove="setActive(index)">
                <slot name="result" :item="item">{{ item[optionName] }}</slot>
            </div>
        </aside>

        <aside v-show="noResults" class="lookup__results">
            <div class="lookup__item">
                <slot name="no-results">Nothing found</slot>
            </div>
        </aside>

        <div class="lookup__tags">
            <div :key="index" class="lookup__tag" v-for="(item, index) in selected">
                <slot name="selected" :item="item">{{ item[optionName] }}</slot>
                <div @click="removeSelectedItem(item)" class="lookup__tag__close">
                    <icon type="close" color="gray" size="18"></icon>
                </div>
            </div>
        </div>
    </article>
</template>
<script type="text/babel">
/* global EventBus */
import AbstractSearch from './AbstractSearch'
import Icon from './Icon'

export default {
    extends: AbstractSearch,

    props: {
        id: {
            type: String,
            default: null
        },

        options: {
            type: Array,
            required: true
        },

        optionKey: {
            type: String,
            default: 'id'
        },

        optionName: {
            type: String,
            default: 'name'
        },

        placeholder: {
            type: String,
            default: 'Search...'
        },

        searchBy: {
            required: false,
            type: Array,
            default () {
                return []
            }
        },

        value: {
            type: Array
        },

        preventHit: {
            type: Function,
            default: null
        }
    },

    watch: {
        value: {
            immediate: true,
            handler (answers) {
                if (answers instanceof Array) {
                    this.selected = []

                    answers.forEach((answer) => {
                        let option = this.findOption(answer)

                        this.selected.push(option)
                    })
                }
            }
        }
    },

    data () {
        return {
            searchByKeys: this.searchBy,
            selected: []
        }
    },

    created () {
        if (this.searchByKeys.length === 0) {
            this.searchByKeys = [this.optionName]
        }

        EventBus.$on('AppClick', (event) => {
            if (!this.$el.contains(event.target)) {
                this.reset()
            }
        })
    },

    methods: {
        removeSelectedItem (item) {
            this.selected = this.selected.filter((selectedItem) => {
                return selectedItem[this.optionKey] !== item[this.optionKey]
            })

            this.updateValue()
        },

        updateValue () {
            this.$emit('input', this.selectedKeys)
        },

        onHit (event, item) {
            event.preventDefault()

            if (this.preventHit && this.preventHit(item) === true) {
                return
            }

            this.selected.push(item)
            this.updateValue()
            this.reset()
        },

        findOption (answer) {
            for (let option of this.options) {
                if (option[this.optionKey] === answer) {
                    return option
                }
            }

            return null
        },

        fetch () {
            this.items = this.unselectedOptions.filter((option) => {
                for (let searchKey of this.searchByKeys) {
                    if (option[searchKey] && option[searchKey].toLowerCase().includes(this.query.toLowerCase())) {
                        return true
                    }
                }

                return false
            })
        }
    },

    computed: {
        selectedKeys () {
            return _.map(this.selected, this.optionKey)
        },

        unselectedOptions () {
            return this.options.filter((option) => {
                return !this.selectedKeys.includes(option[this.optionKey])
            })
        }
    },

    components: {
        Icon
    }
}
</script>
